import { ProvisionView as Provision } from '@bymason-private/controller-shared-widgets';

import { Button } from '@bymason-private/legacy-pattern-components';
import { RouterButton } from '@bymason-private/route-provider';

import Layout from '../../common/layout';
import { routes } from '../../router';

function ProvisionView() {
  return (
    <Layout
      headerText='Provision'
      headerRightAdornment={
        <RouterButton
          route={routes.Devices}
          buttonComponent={
            <Button color='error' variant='contained'>
              End session
            </Button>
          }
        />
      }
      stickyHeader
    >
      <Provision groupDetailsViewRoute={routes.Group} devicesViewRoute={routes.Devices} />
    </Layout>
  );
}

export default ProvisionView;
